<template>
  <page-edicion title="Editar Unidad de Negocio">
    <formulario
      :unidad-negocio="unidadNegocio"
      :paises-id="paisesId"
      :tarifa="tarifa"
      :opciones-paises="opcionesPaises"
      :opciones-tarifas="opcionesTarifas"
      @submit="actualizar"
    />
  </page-edicion>
</template>

<script>
import Formulario from "./Formulario";
import * as unidadesNegocioApi from "@/services/unidadesNegocio";
import * as paisesApi from "@/services/paises";
import tarifasApi from "@/services/tarifas";

export default {
  components: { Formulario },
  data() {
    return {
      unidadNegocio: {},
      paises: [],
      paisesId: [],
      opcionesPaises: [],
      tarifas: [],
      tarifa: tarifasApi.crear(),
      opcionesTarifas: [],
    };
  },
  mounted() {
    this.cargar(this.$route.params.id);
  },
  methods: {
    cargar(id) {
      unidadesNegocioApi.cargar(id).then((response) => {
        this.unidadNegocio = response.unidadNegocio;
        this.paises = response.paises;
        var p = {};
        for (p in this.paises) {
          paisesApi.cargar(this.paises[p].paisId).then((response) => {
            this.paisesId.push(response.pais.id); //array id paises para v-model
            //array opciones nombre pais para opciones selected combo multiple
            this.opcionesPaises.push({
              id: response.pais.id,
              text: response.pais.nombre,
            });
          });
        }
        tarifasApi.cargar(this.unidadNegocio.tarifaId).then((response) => {
          this.tarifa = response;
          //array opciones nombre tarifa para opciones selected combo
          this.opcionesTarifas.push({
            id: response.id,
            text: response.nombre,
          });
        });
      });
    },
    actualizar(paisesSeleccionados) {
      if (paisesSeleccionados.length > 0) {
        this.paises = paisesSeleccionados;
      }

      var unidadNegocio = {
        unidadNegocio: this.unidadNegocio,
        paises: this.paises,
      };
      unidadesNegocioApi.actualizar(unidadNegocio).then(() => {
        this.$router.push({ path: "/unidadesNegocio" });
      });
    },
  },
};
</script>
